import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var usePDFJS = function usePDFJS() {
  var pdf = ref(null);
  function load(_x) {
    return _load.apply(this, arguments);
  }
  function _load() {
    _load = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(src) {
      var pdfjsLib, loadingTask;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('pdfjs-dist/legacy/build/pdf.js');
          case 2:
            pdfjsLib = _context.sent;
            pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js?v1';
            loadingTask = pdfjsLib.getDocument(src);
            _context.next = 7;
            return loadingTask.promise;
          case 7:
            pdf.value = _context.sent;
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _load.apply(this, arguments);
  }
  function destroy() {
    var _pdf$value, _pdf$value2;
    (_pdf$value = pdf.value) === null || _pdf$value === void 0 ? void 0 : _pdf$value.cleanup();
    (_pdf$value2 = pdf.value) === null || _pdf$value2 === void 0 ? void 0 : _pdf$value2.destroy();
    pdf.value = null;
  }
  return {
    pdf: pdf,
    destroy: destroy,
    load: load
  };
};